import { writable } from "svelte/store";

const createAuthStore = () => {
  const initialAccessToken = typeof localStorage !== 'undefined' ? localStorage.getItem('access_token') : null;
  const initialRefreshToken = typeof localStorage !== 'undefined' ? localStorage.getItem('refresh_token') : null;

  const { subscribe, set, update } = writable({
    user: null,
    profile: null,
    isBusiness: false,
    isAdmin: false,
    isSuperAdmin: false,
    accessToken: initialAccessToken,
    refreshToken: initialRefreshToken,
    showLoginPrompt: false
  });

  return {
    subscribe,
    update,
    setUserAndProfile: (userAccount, userProfile) => {
      const role = userProfile?.role || 'user';
      const isSuper = role === 'super_admin';
      const isAdmin = isSuper || role === 'admin';

      update((state) => ({
        ...state,
        user: userAccount,
        profile: userProfile,
        isBusiness: userProfile?.isBusinessAccount || false,
        isAdmin: isAdmin,
        isSuperAdmin: isSuper
      }));
    },
    setTokens: (accessToken, refreshToken) => {
      if (typeof localStorage !== 'undefined') {
        if (accessToken) localStorage.setItem('access_token', accessToken);
        if (refreshToken) localStorage.setItem('refresh_token', refreshToken);
      }
      update((state) => ({
        ...state,
        accessToken,
        refreshToken: refreshToken !== undefined ? refreshToken : state.refreshToken,
        showLoginPrompt: false
      }));
    },
    promptLogin: () => {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
      }
      update((state) => ({
        ...state,
        user: null,
        profile: null,
        isBusiness: false,
        isAdmin: false,
        isSuperAdmin: false,
        accessToken: null,
        refreshToken: null,
        showLoginPrompt: true
      }));
    },
    dismissLoginPrompt: () => {
      update((state) => ({ ...state, showLoginPrompt: false }));
    },
    clearUser: () => {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
      }
      set({
        user: null,
        profile: null,
        isBusiness: false,
        isAdmin: false,
        isSuperAdmin: false,
        accessToken: null,
        refreshToken: null,
        showLoginPrompt: false
      });
    },
  };
};

export const authStore = createAuthStore();
